// THE APP STRIP — the Rail (DESIGN-WL-HOME-TOP-STRIP-SUMMARY-1; Nika's pick
// 2026-09-28 row 1 "A or C": both ship as a personal option, this file is C).
// A slim vertical rail BESIDE the board: the same calm glyph tiles as the Dock
// (components/HomeAppStrip.js `HomeAppStripItem`), the names on hover and
// focus, or beside the glyphs when the person turns names on. It frees the top
// of the home for the greeting and the summary.
//
// PLACEMENT: a child of the home page itself (the page is the full-bleed
// flow-x AppPage), before the scrolling main column — so it takes its own box
// and the board narrows to the room that is left (the board's columns follow
// its own width, a container query), never an overlay over the cards
// (Rule 66). It does not scroll with the board. Its top matches the page
// head's (the main column's `D1` top inset under the floating header).
//
// ON A PHONE (the brand's `mobileL` step) the Rail steps aside and the Dock
// row stays in its place (the Dock's rule is keyed on the exact complement,
// the shell's `aboveMobileL`) — a vertical rail would take a fifth of a
// phone's width.
//
// The page supplies the items (pages/main.js `_appStripRows`, the same rows as
// the Dock) and, like the Dock, hides the Rail when no app is left to show
// (`_appStripHidden`). The capsule is the skin's `pill`; the component never
// reads the skin.
export const HomeAppRail = {
  tag: 'nav',
  class: 'home-app-rail',
  'aria-label': (el) => el.call('polyglot', 'workspace.home.appStrip'),
  hide: (el, s) => el.call('homeAppStripLookHidden', s.root, 'rail'),
  '@mobileL': { display: 'none' },
  display: 'flex',
  flexDirection: 'column',
  alignSelf: 'flex-start',
  flexShrink: '0',
  minHeight: '0',
  maxHeight: 'calc(100% - var(--spacing-D1) * 2)',
  // The page head's top (the main column's D1 inset), the board's gutter.
  margin: 'D1 0 0 C',
  // Room for the focus ring around the capsule's scroll box.
  padding: 'X',

  animation: 'fadeInUpShort',
  animationDuration: 'C',
  animationTimingFunction: 'defaultBezier',
  animationFillMode: 'backwards',

  RailCapsule: {
    class: 'home-app-rail-capsule',
    theme: 'pill',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    gap: 'Y',
    minHeight: '0',
    padding: 'Y',
    round: 'radiusCard',
    // the Rail index (HomeAppStripItem): numbers restart per capsule
    counterReset: 'rail-app',
    overflowY: 'auto',
    overflowX: 'hidden',
    overscrollBehavior: 'contain',
    scrollbarWidth: 'none',
    '::-webkit-scrollbar': { display: 'none' },

    Items: {
      tag: 'fragment',
      childExtends: 'HomeAppStripItem',
      childrenAs: 'state',
      children: []
    },

    // The last item: the whole catalogue (the header's search launcher).
    HomeAppStripAll: {}
  }
}
